// extracted by mini-css-extract-plugin
export default {"BreadCrumbs":"BreadCrumbs_BreadCrumbs__iuTfE","description":"BreadCrumbs_description__GZVlT"};